import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoPaddingFilledInfoIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 4.5,
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 3V5.5",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 7.375,
			r: .5,
			fill: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgNoPaddingFilledInfoIcon);
const Memo = memo(ForwardRef);
export default Memo;
